<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block purple-theme">
  <mat-card-header>
    <mat-card-title>Obrazac B2 - Proračun</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (projectBudgetForm) {
      <form [formGroup]="projectBudgetForm">
        <!-- DIRECT COSTS -->
        <h3>POGLAVLJE A) IZRAVNI TROŠKOVI</h3>
        <mat-accordion formArrayName="directCosts">
          @for (projectBudgetItem of directCosts.controls; track projectBudgetItem; let i = $index) {
            <mat-expansion-panel #directPanel  [formGroupName]="i">
              <mat-expansion-panel-header class="no-wrap-header">
                <mat-panel-title>
                  {{ projectBudgetItem.get('description')?.value || 'Izravna stavka troška ' + (i + 1) }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="actions">
                <button mat-icon-button color="primary" (click)="closePanel(directPanel)" matTooltip="Završite uređivanje stavke" [disabled]="projectBudgetItem.invalid">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="removeProjectBudgetItem(budgetType.Direct, i)" matTooltip="Uklonite stavku">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <mat-form-field class="mb-25">
                <mat-label>Vrsta troška</mat-label>
                <textarea #directDescriptionInputs matInput formControlName="description"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Iznos tražen od Općine (EUR)</mat-label>
                <input matInput formattedNumber  [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amountRequested" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Ukupan iznos troška (EUR)</mat-label>
                <input matInput formattedNumber  [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="totalAmount" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Objašnjenje proračunske stavke</mat-label>
                <textarea matInput formControlName="explanation"></textarea>
              </mat-form-field>
              <app-file-upload
                [storageLocation]="projectBudgetItem.get('fileStorageLocation')?.value"
              ></app-file-upload>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" (click)="addProjectBudgetItem(budgetType.Direct)" [disabled]="projectBudgetForm.invalid">
          Dodaj Izravni Trošak
        </button>
        <div class="totals">
          <h4>
            Ukupno POGLAVLJE A) IZRAVNI TROŠKOVI (traženo / ukupno):
            {{ totalDirectCostsRequested | currency:'EUR' }} / {{ totalDirectCostsActual | currency:'EUR' }}
          </h4>
        </div>
        <mat-divider></mat-divider>
        <!-- INDIRECT COSTS -->
        <h3>POGLAVLJE B) NEIZRAVNI TROŠKOVI</h3>
        <mat-accordion formArrayName="indirectCosts">
          @for (projectBudgetItem of indirectCosts.controls; track projectBudgetItem; let i = $index) {
            <mat-expansion-panel #indirectPanel [formGroupName]="i" >
              <mat-expansion-panel-header class="no-wrap-header">
                <mat-panel-title>
                  {{ projectBudgetItem.get('description')?.value || 'Neizravna stavka troška ' + (i + 1) }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="actions">
                <button mat-icon-button color="primary" (click)="closePanel(indirectPanel)" matTooltip="Završite uređivanje stavke" [disabled]="projectBudgetItem.invalid">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="removeProjectBudgetItem(budgetType.Indirect, i)" matTooltip="Ukloni">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <mat-form-field class="mb-25">
                <mat-label>Vrsta troška</mat-label>
                <textarea #indirectDescriptionInputs matInput formControlName="description"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Iznos tražen od Općine (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amountRequested" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Ukupan iznos troška (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="totalAmount" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Objašnjenje proračunske stavke</mat-label>
                <textarea matInput formControlName="explanation"></textarea>
              </mat-form-field>
              <app-file-upload
                [storageLocation]="projectBudgetItem.get('fileStorageLocation')?.value"
              ></app-file-upload>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" (click)="addProjectBudgetItem(budgetType.Indirect)" [disabled]="projectBudgetForm.invalid">
          Dodaj neizravni trošak
        </button>
        <div class="totals">
          <h4>
            Ukupno POGLAVLJE B) NEIZRAVNI TROŠKOVI (traženo / ukupno):
            {{ totalIndirectCostsRequested | currency:'EUR' }} / {{ totalIndirectCostsActual | currency:'EUR' }}
          </h4>
        </div>
        <mat-divider></mat-divider>
        <div class="totals">
          <h3>
            SVEUKUPNO (A + B) (traženo / ukupno):
            {{ totalCostsRequested | currency:'EUR' }} / {{ totalCostsActual | currency:'EUR' }}
          </h3>
        </div>
        <mat-divider></mat-divider>
        <h3>OSTALI IZVORI FINANCIRANJA</h3>
        <div formArrayName="projectFundingSources">
          @for (projectFundingSource of projectFundingSources.controls; track projectFundingSource; let i = $index) {
            <div [formGroupName]="i" class="funding-source">
              <mat-form-field class="mb-25">
                <mat-label>{{ getFundingSourceLabel(projectFundingSource.get('type')?.value) }} (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amount" />
              </mat-form-field>
            </div>
          }
        </div>
        <div class="totals">
          <h4>SVEUKUPNO (I + II + III + IV): {{ totalFundingFromOtherSources | currency:'EUR' }}</h4>
        </div>
        <mat-divider></mat-divider>
        <div class="totals">
          <h3>SVEUKUPNI IZNOS TROŠKOVA PROGRAMA / PROJEKTA - SVI IZVORI: {{ totalFunding | currency:'EUR' }}</h3>
        </div>
      </form>
    }

    <app-budget-status
      [projectApprovedAmount]="projectApprovedAmount"
      [totalCostsRequested]="totalCostsRequested"
      [totalCostsActual]="totalCostsActual"
      [totalFundingFromOtherSources]="totalFundingFromOtherSources">
    </app-budget-status>

    <button mat-raised-button color="accent" class="submit-btn" (click)="onSubmit()">
      Ažuriraj proračun
    </button>

  </mat-card-content>
</mat-card>